import { fromEnum } from '../utils/from-enum';

export enum OauthProvider {
  // Do not change -- used in DB.
  Intuit = 'intuit',
  Google = 'google',
  Microsoft = 'microsoft',
}

export const OauthProviderT = fromEnum(OauthProvider);

export interface OauthStatusDto {
  connected: boolean;
}
